import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class ABTestTimeoutTrackingEvent extends BasicTrackingEvent {
    public playerId: number = 0;
    public testID: number;
    public accountID: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.playerId = this.playerId;
        vars.var_2 = this.testID;
        vars.var_4 = this.accountID;
        vars.var_data = this.referrer;
        return vars;
    }
}
